import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "isChecked", "mode", "id", "onChange", "onClick", "value", "field", "iserror", "background", "disabled", "testId"];
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import * as React from 'react';
import { Checkbox as FlowBiteCheckbox } from 'flowbite-react';
import { useAuth } from '@restworld/feature-authentication';
import { StyledRadioHoverEl } from '../radio-group';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Checkbox = function Checkbox(props) {
  var title = props.title,
      isChecked = props.isChecked,
      _props$mode = props.mode,
      mode = _props$mode === void 0 ? 'clickable' : _props$mode,
      id = props.id,
      _props$onChange = props.onChange,
      onChange = _props$onChange === void 0 ? function () {
    return null;
  } : _props$onChange,
      onClick = props.onClick,
      value = props.value,
      field = props.field,
      iserror = props.iserror,
      background = props.background,
      disabled = props.disabled,
      testId = props.testId,
      rest = _objectWithoutProperties(props, _excluded);

  var _useAuth = useAuth(),
      isAuthenticated = _useAuth.isAuthenticated;

  var checkboxEl = /*#__PURE__*/_jsxs(_StyledSpan, {
    children: [/*#__PURE__*/_jsx(CheckboxStyled, _objectSpread(_objectSpread({
      "data-cy": testId,
      id: id,
      checked: isChecked,
      onChange: onChange,
      onClick: onClick,
      authenticated: isAuthenticated.toString(),
      value: value,
      iserror: iserror === null || iserror === void 0 ? void 0 : iserror.toString(),
      background: background,
      disabled: disabled
    }, field), rest)), /*#__PURE__*/_jsx(StyledRadioHoverEl, {})]
  });

  return /*#__PURE__*/_jsxs(Wrapper, {
    disabled: disabled,
    ischecked: isChecked,
    background: background,
    htmlFor: id,
    authenticated: isAuthenticated,
    mode: mode,
    children: [checkboxEl, !!title && (typeof title === 'string' ? /*#__PURE__*/_jsx(LabelStyled, {
      children: title
    }) : title)]
  });
};
export default Checkbox;
var noPointerStyle = {
  "pointerEvents": "none",
  "cursor": "auto"
};
var pointerStyle = {
  "pointerEvents": "auto",
  "cursor": "pointer"
};

var Wrapper = /*#__PURE__*/_styled.label.attrs({
  className: 'group'
}).withConfig({
  displayName: "checkboxbasic__Wrapper",
  componentId: "sc-1y3siq6-0"
})(["", " ", " ", " ", " ", ""], {
  "display": "flex",
  "width": "fit-content",
  "alignItems": "center",
  "gap": "10px",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(75 85 99 / var(--tw-text-opacity))",
  ":focus-visible": {
    "outlineWidth": "4px",
    "outlineColor": "#e88a99"
  }
}, function (_ref) {
  var mode = _ref.mode;
  return mode === 'static' ? noPointerStyle : pointerStyle;
}, function (_ref2) {
  var background = _ref2.background;
  return background === 'primary' ? {
    "borderRadius": "0.5rem",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(246 245 255 / var(--tw-bg-opacity))",
    "padding": "1rem"
  } : {};
}, function (_ref3) {
  var ischecked = _ref3.ischecked,
      background = _ref3.background;
  return background && ischecked ? {
    "borderWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(105 62 181 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(226 216 243 / var(--tw-bg-opacity))"
  } : {};
}, function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled ? {
    "pointerEvents": "none",
    "cursor": "not-allowed",
    "opacity": "0.6",
    "--tw-saturate": "saturate(.25)",
    "filter": "var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)"
  } : {
    "pointerEvents": "auto",
    "cursor": "pointer"
  };
});

var CheckboxStyled = /*#__PURE__*/_styled(FlowBiteCheckbox).withConfig({
  displayName: "checkboxbasic__CheckboxStyled",
  componentId: "sc-1y3siq6-1"
})(["", " ", " ", ""], {
  "position": "relative",
  "zIndex": "10",
  "height": "16px",
  "width": "16px",
  "borderRadius": "0.25rem",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(133 133 145 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))",
  "padding": "0.5rem",
  ":checked": {
    "--tw-bg-opacity": "1 !important",
    "backgroundColor": "rgb(102 51 187 / var(--tw-bg-opacity)) !important"
  },
  ".group:hover &": {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(102 51 187 / var(--tw-border-opacity))"
  },
  ":focus": {
    "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
    "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
    "boxShadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)"
  },
  ":disabled": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(222 222 225 / var(--tw-bg-opacity))"
  }
}, function (_ref5) {
  var iserror = _ref5.iserror;
  return iserror === 'true' ? {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(204 0 34 / var(--tw-border-opacity))"
  } : {};
}, function (_ref6) {
  var disabled = _ref6.disabled;
  return disabled ? {
    ":checked": {
      "--tw-bg-opacity": "1 !important",
      "backgroundColor": "rgb(133 133 145 / var(--tw-bg-opacity)) !important"
    }
  } : {};
});

var LabelStyled = /*#__PURE__*/_styled.span.withConfig({
  displayName: "checkboxbasic__LabelStyled",
  componentId: "sc-1y3siq6-2"
})(["", " ", ""], {
  "cursor": "pointer",
  "fontSize": "1rem !important",
  "lineHeight": "1.5rem !important",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(28 28 51 / var(--tw-text-opacity))"
}, function (_ref7) {
  var disabled = _ref7.disabled;
  return disabled ? {
    "cursor": "not-allowed",
    "--tw-text-opacity": "1",
    "color": "rgb(117 117 131 / var(--tw-text-opacity))"
  } : {};
});

var _StyledSpan = /*#__PURE__*/_styled("span").withConfig({
  displayName: "checkboxbasic___StyledSpan",
  componentId: "sc-1y3siq6-3"
})({
  "position": "relative",
  "display": "grid",
  "placeItems": "center"
});